import { useMutation } from '@tanstack/react-query';
import { postMatch, type MatchRequestBody } from '../api/match-api';

export function usePostMatchMutation() {
  return useMutation({
    mutationFn: (body: MatchRequestBody) => postMatch(body),
  });
}
